__turbopack_context__.v({
  "accordion_item": "styles-module-scss-module__0ae18q__accordion_item",
  "content_container": "styles-module-scss-module__0ae18q__content_container",
  "heading": "styles-module-scss-module__0ae18q__heading",
  "icon": "styles-module-scss-module__0ae18q__icon",
  "label_container": "styles-module-scss-module__0ae18q__label_container",
  "theme_red": "styles-module-scss-module__0ae18q__theme_red",
  "title": "styles-module-scss-module__0ae18q__title",
  "topic_record_link": "styles-module-scss-module__0ae18q__topic_record_link",
});
